import React from "react";
import { Navigate } from "react-router-dom";

// Decode JWT exp claim without verifying signature (client-side expiry check only).
function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp && Date.now() / 1000 > payload.exp;
  } catch {
    return true;
  }
}

function AdminProtectedRoute({ children }) {
  const saved = localStorage.getItem("admin");
  const admin = saved ? JSON.parse(saved) : null;

  if (!admin || !admin.token) {
    return <Navigate to="/admin-login" replace />;
  }

  if (isTokenExpired(admin.token)) {
    localStorage.removeItem("admin");
    return <Navigate to="/admin-login" replace />;
  }

  return children;
}

export default AdminProtectedRoute;
